/*
    Import all individual JS into a single bundle
*/

// libraries - dependencies
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/util';
import './vendor/slick.js';

import { initAgenda } from './app/agenda/agenda';
import { initCarousel } from './app/carousel/carousel';
import { handleMobileMenu } from './app/mobile-menu/mobile-menu';
import { initSlider } from './app/slider/slider';
import { initDropdown } from './app/dropdown/dropdown';
import { initContactForm } from './app/contact-form/contact-form';

handleMobileMenu('#header__menu-icon', '#header__mobile-menu');
initCarousel('#carousel-icons');
initSlider('#js-slider');
initDropdown('.js-dropdown');
initContactForm('#contact-form');
initAgenda();
